import { FC, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { BASE_URL } from '@src/utils/constants';
import { LoaderComponent } from '@component/LoaderComponent/LoaderComponent';
import { logger } from '@utils/logger';

export const MicrosoftCallback: FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  logger.log('Microsoft searchParams--->', searchParams);

  useEffect(() => {
    const code = searchParams.get('code');
    logger.log('Microsoft has code ???', code);

    if (code) {
      axios
        .post(`${BASE_URL}/auth/microsoft`, { code }, { withCredentials: true })
        .then(() => {
          logger.log(
            'requesting---->',
            `${BASE_URL}/auth/microsoft`,
            'code---->',
            code
          );
          navigate('/');
        })
        .catch((error) => {
          logger.log('Microsoft login error', error);
          navigate('/authorization/login');
        });
    }
  }, [searchParams, navigate]);

  return <LoaderComponent />;
};
